import { alpha, type Theme } from "@mui/material/styles";

/** How far a shadow reaches into the box, and how far the cover that hides it at the end reaches. */
const SHADOW_HEIGHT = "12px";
const COVER_HEIGHT = "32px";

/**
 * Draws a shadow on the edge of a scroll box that has more content past it, and none on an edge it is
 * scrolled to (#7004). A phone draws no scrollbar, so without this a field clipped at the box's edge
 * looked absent rather than out of view: an hourly rate's Team Member, under the category panel's
 * pinned buttons.
 *
 * CSS alone, so it needs no scroll listener and no measuring. The two shadows are fixed to the box
 * (`scroll`), and two covers in the box's own background color scroll with the content (`local`). At
 * the top of the content the top cover lies over the top shadow; scrolled away, it leaves with the
 * content and the shadow shows. The bottom works the same way. Content drawn with its own background
 * paints over all four, so the box's children keep a transparent one, as outlined fields do.
 */
export function scrollShadows(theme: Theme) {
  const background = theme.palette.background.paper;
  const shadow = alpha(theme.palette.common.black, 0.2);

  return {
    background: [
      `linear-gradient(${background} 30%, ${alpha(background, 0)}) center top / 100% ${COVER_HEIGHT} no-repeat local`,
      `linear-gradient(${alpha(background, 0)}, ${background} 70%) center bottom / 100% ${COVER_HEIGHT} no-repeat local`,
      `radial-gradient(farthest-side at 50% 0, ${shadow}, transparent) center top / 100% ${SHADOW_HEIGHT} no-repeat scroll`,
      `radial-gradient(farthest-side at 50% 100%, ${shadow}, transparent) center bottom / 100% ${SHADOW_HEIGHT} no-repeat scroll`,
    ].join(", "),
    backgroundColor: background,
  } as const;
}
